import { render } from "./VFooter.vue?vue&type=template&id=9e336b4a"
const script = {}

import "./VFooter.vue?vue&type=style&index=0&id=9e336b4a&lang=scss"

import exportComponent from "E:\\Project\\Vue\\keep-calm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__